module.exports = __webpack_public_path__ + "img/b1177514b930069abdd2af8e6acc67eb.fb472239.png";